import React from 'react'
import HorizontalTabs from '../components/HorizontalTabs';
import { Link } from 'react-router-dom';

import data from '../data.json';
import { LazyLoadImage } from 'react-lazy-load-image-component';

function classexhibition() {
  const tabs = [

    // early years data
    // {title: 'Early Years', content: () =>  <div>
    //   <div className='cam-lower-sec'>
    //       <h1 className='title'>Early Years 2024-25</h1>

          
    //     </div>
    //      <div className='photo-sec'>
     
    //   <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-2.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-2.webp'></img>
    //     </Link>
    //   </div>
     
    //   <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-3.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-3.webp'></img>
    //     </Link>
    //   </div>
    
    //   <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-4.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-4.webp'></img>
    //     </Link>
    //   </div>
      
    //   <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-5.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-5.webp'></img>
    //     </Link>
    //   </div>
     
    //   <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-7.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-7.webp'></img>
    //     </Link>
    //   </div>
  
    //   <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-8.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-8.webp'></img>
    //     </Link>
    //   </div>
     
    //   <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-10.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-10.webp'></img>
    //     </Link>
    //   </div>
   
    //   <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-11.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-11.webp'></img>
    //     </Link>
    //   </div>
    
    //   <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-12.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-12.webp'></img>
    //     </Link>
    //   </div>
     
    //   <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-13.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-13.webp'></img>
    //     </Link>
    //   </div>
      
    //   <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-14.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-14.webp'></img>
    //     </Link>
    //   </div>
      
    //   <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-15.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-15.webp'></img>
    //     </Link>
    //   </div>
      
    //   <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-16.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-16.webp'></img>
    //     </Link>
    //   </div>
      
    //   <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-17.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-17.webp'></img>
    //     </Link>
    //   </div>
      
    //   <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-18.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-18.webp'></img>
    //     </Link>
    //   </div>
    
    //   <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-19.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-19.webp'></img>
    //     </Link>
    //   </div>
    
    //   <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-20.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-20.webp'></img>
    //     </Link>
    //   </div>
      
    //   <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-21.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-21.webp'></img>
    //     </Link>
    //   </div>
    
    //   <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-22.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-22.webp'></img>
    //     </Link>
    //   </div>
      
    //   <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-24.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-24.webp'></img>
    //     </Link>
    //   </div>
     
    //   <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-25.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-25.webp'></img>
    //     </Link>
    //   </div>
    
    //   <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-26.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-26.webp'></img>
    //     </Link>
    //   </div>
     
    //   <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-27.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-27.webp'></img>
    //     </Link>
    //   </div>
      
    //   <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-28.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-28.webp'></img>
    //     </Link>
    //   </div>
    
    //   <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-29.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-29.webp'></img>
    //     </Link>
    //   </div>
     
    //   <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-30.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-30.webp'></img>
    //     </Link>
    //   </div>
     
    //   <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-31.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-31.webp'></img>
    //     </Link>
    //   </div>
      
    //     <div className='photo-box'>
    //   <Link to="../img/Class-Exhibition/Early Years/Pre Primary Show 2024-32.webp"
    //       target="_blank"
    //       rel="noopener noreferrer">
    //      <img src='../img/Class-Exhibition/Early Years/Pre Primary Show 2024-32.webp'></img>
    //     </Link>
    //   </div>

    //   </div>
    // </div>

    // },

   { title: 'PYP Grade I', content: () => <div>
    <div className='cam-lower-sec'>
    <h1 className='title'>PYP Grade I Exhibition 2026-27</h1>
    </div>
     <div className="photo-sec">
                          {data.Events.ClsI.map((person) => (
                      <div key={person.id} className="photo-box">
                        <Link 
                          to={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`} 
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <LazyLoadImage 
                            src={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`} 
                            alt={person.alt} 
                          />
                        </Link>
                      </div>
                  ))}
                        </div>
    </div> },
  { title: 'PYP Grade II', content: () => <div>
<div className='cam-lower-sec'>
    <h1 className='title'>PYP Grade II Exhibition 2026-27</h1>
    </div>
     <div className="photo-sec">
                          {data.Events.ClsII.map((person) => (
                      <div key={person.id} className="photo-box">
                        <Link 
                          to={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`} 
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <LazyLoadImage 
                            src={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`} 
                            alt={person.alt} 
                          />
                        </Link>
                      </div>
                  ))}
                        </div>
    </div> },

 { title: 'PYP Grade III', content: () => <div>
<div className='cam-lower-sec'>
    <h1 className='title'>PYP Grade III Exhibition 2026-27</h1>
    </div>
   <div className="photo-sec">
                          {data.Events.ClsIII.map((person) => (
                      <div key={person.id} className="photo-box">
                        <Link 
                          to={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`} 
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <LazyLoadImage 
                            src={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`} 
                            alt={person.alt} 
                          />
                        </Link>
                      </div>
         
                  ))}
                        </div>
    </div> },
{ title: 'PYP Grade IV', content: () => <div>
     <div className='cam-lower-sec'>
    <h1 className='title'>PYP Grade IV Exhibition 2025-26</h1>
    </div>
   <div className="photo-sec">
                          {data.Events.ClsIV.map((person) => (
                      <div key={person.id} className="photo-box">
                        <Link 
                          to={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`} 
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <LazyLoadImage 
                            src={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`} 
                            alt={person.alt} 
                          />
                        </Link>
                      </div>
         
                  ))}
                        </div>
  
  

    

    </div> },
  
  { title: 'PYP Grade V', content: () => <div>
    
    {/* <div className='cam-lower-sec'>
    <h1 className='title'>IBPYP</h1>
    </div> */}

    <div className='cam-lower-sec'>
    <h1 className='title'>PYP Grade V Exhibition 2025-26</h1>
    </div>
    <div className='photo-sec'>
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/2025/img01.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/2025/img01.webp'></img>
        </Link>
      </div>
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/2025/img02.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/2025/img02.webp'></img>
        </Link>
      </div>
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/2025/img03.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/2025/img03.webp'></img>
        </Link>
      </div>
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/2025/img04.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/2025/img04.webp'></img>
        </Link>
      </div>
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/2025/img05.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/2025/img05.webp'></img>
        </Link>
      </div>
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/2025/img06.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/2025/img06.webp'></img>
        </Link>
      </div>
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/2025/img07.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/2025/img07.webp'></img>
        </Link>
      </div>
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/2025/img08.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/2025/img08.webp'></img>
        </Link>
      </div>
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/2025/img09.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/2025/img09.webp'></img>
        </Link>
      </div>
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/2025/img10.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/2025/img10.webp'></img>
        </Link>
      </div>
    </div>
    <br />
    <div className='cam-lower-sec'>
    <h1 className='title'>PYP Grade V Exhibition 2024-25</h1>
    </div>
    <div className='photo-sec'>
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-1.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-1.webp'></img>
        </Link>
      </div>
      
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-2.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-2.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-3.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-3.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-4.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-4.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-5.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-5.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-6.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-6.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-7.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-7.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-8.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-8.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-9.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-9.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-10.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-10.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-11.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-11.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-12.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-12.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-13.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-13.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-14.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-14.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-15.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-15.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-16.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-16.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-17.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-17.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-18.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-18.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-19.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-19.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-20.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-20.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-21.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-21.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-22.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-22.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-23.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-23.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-24.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-24.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-25.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-25.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-26.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-26.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-27.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-27.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-28.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-28.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-29.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-29.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-30.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-32.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-33.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-33.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-34.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-34.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-35.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-35.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-36.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-36.webp'></img>
        </Link>
      </div>
      
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-37.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-37.webp'></img>
        </Link>
      </div>
   
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-38.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-38.webp'></img>
        </Link>
      </div>
    
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-39.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-39.webp'></img>
        </Link>
      </div>
    
      <div className='photo-box'>
      <Link to="../img/Class-Exhibition/Class V/Class V Show 2024-40.webp"
          target="_blank"
          rel="noopener noreferrer">
         <img src='../img/Class-Exhibition/Class V/Class V Show 2024-40.webp'></img>
        </Link>
      </div>
  
    </div>

      <br/>
    


    </div> },

    
  ]
  return (
    <div>
     <div className='ibdp-hero-sec'>
        <img src='newimg/Class IV Show 2024-24.webp'/>

      </div>
      <div className="newsletter-sec">
      <HorizontalTabs tabs={tabs} />
      </div>


    </div>
  )
}

export default classexhibition
